import { useRef } from 'react';
import { useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
export default function Captcha(props: any) {
    const captchaRef = useRef<any>(null);
    const onChange = (value: any) => {
        props?.formik?.setFieldValue('captcha', value);
    };
    useEffect(() => {
        if (props.value == null) {
            captchaRef?.current?.reset();
        }
    }, [props.value]);
    return (
        <div className="captcha">
            {/* <img width="100%" src="/images/captcha.svg" alt="" /> */}
            <ReCAPTCHA
                ref={captchaRef}
                sitekey={process.env.REACT_APP_CAPTCH_SITE_KEY || ''}
                onChange={onChange}
            />
            {props?.formik?.touched?.captcha && props?.formik?.errors?.captcha && (
                <p
                    style={{
                        color: '#7A0000',
                        fontSize: '12px',
                        fontFamily: 'Montserrat-Medium',
                        paddingLeft: '10px',
                    }}
                >
                    {props.formik.errors.captcha}
                    {''}
                </p>
            )}
        </div>
    );
}
